module.exports = __webpack_public_path__ + "img/horizontal_4_2_1.c4e675f9.png";